// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UHh1","col":"styles_col__3pEJC","actions":"styles_actions__3zBWI","conflict":"styles_conflict__1Xm4q"};